import { baseApi } from '../baseApi';

import { Deal } from './Deal';
import { LoyaltyGroup } from './LoyaltyGroup';

const dealSlice = baseApi
  .enhanceEndpoints({
    addTagTypes: ['Deals', 'LoyaltyGroups'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDeals: builder.query<Deal[], { loyaltyGroupId?: number }>({
        keepUnusedDataFor: 300,
        query: ({ loyaltyGroupId }) => ({
          url: '/deals',
          method: 'GET',
          params: loyaltyGroupId ? { loyaltyGroupId } : undefined,
          headers: {
            'x-api-version': '1.0',
          },
        }),
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ dealId }) => ({
                  type: 'Deals' as const,
                  id: dealId,
                })),
                { type: 'Deals', id: 'LIST' },
              ]
            : [{ type: 'Deals', id: 'LIST' }],
      }),
      getLoyaltyGroups: builder.query<LoyaltyGroup[], void>({
        keepUnusedDataFor: 300,
        query: () => ({
          url: '/deals/loyalty-groups',
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        providesTags: [{ type: 'LoyaltyGroups', id: 'LIST' }],
      }),
    }),
  });

export const { useGetDealsQuery, useLazyGetDealsQuery, useGetLoyaltyGroupsQuery } = dealSlice;
